import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { calculateFiscalYear, formatYearRanges, noWhitespaceValidator } from 'src/app/shared/commen-function-file';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';

@Component({
  selector: 'app-add-elcm-candidate',
  templateUrl: './add-elcm-candidate.component.html',
  styleUrls: ['./add-elcm-candidate.component.scss'],
})
export class AddElcmCandidateComponent implements OnInit {
  condidateForm!: FormGroup;
  authorities: any[] = [];
  allListingband: any = [];
  buttonColorName: any;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInUserRole: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserName: any | null;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: boolean = false;
  selectedYear: any;
  pmsYears: any = [];
  userEmail: any;
  adminData: { adminId: number | null, adminName: string, adminEMail: string } = {
    adminId: null,
    adminName: '',
    adminEMail: '',
  }
  @HostListener('window:keydown.enter', ['$event'])
  handleEnterKey(event: KeyboardEvent) {
    event.preventDefault(); // Prevents the default enter key behavior
  }

  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<AddElcmCandidateComponent>,
    @Inject(MAT_DIALOG_DATA) public assetdata: any, private config: Config, private encryptionService: EncryptionService,
    private httpService: HttpService, public dialog: MatDialog,) {

    this.condidateForm = this.fb.group({
      firstName: ['', [
        Validators.required,                        // Field is required
        Validators.maxLength(255),                  // Maximum length of 255 characters                   // Minimum length of 2 characters
         Validators.pattern(/^[A-Za-z\s'.]+$/),      // Only letters, spaces, apostrophes, and hyphens allowed
        noWhitespaceValidator                  // Custom validator to disallow only spaces
      ]],


      lastName: [
        '',
        [
          Validators.required,
          Validators.maxLength(255),
           Validators.pattern(/^[A-Za-z\s']+$/), // Only letters, space, apostrophe, hyphen
          noWhitespaceValidator
        ]
      ],
      solutation: ['', Validators.required],
      mail: ['', [Validators.required, Validators.pattern(/^(?!.*\.\.)(?!.*--)(?!.*__)(?![-_.])[a-zA-Z0-9](?:[a-zA-Z0-9]|(?<![-_.])[._-](?![-_.]))*[a-zA-Z0-9]@[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*\.[a-zA-Z]{2,10}(?:\.[a-zA-Z]{2,10})?$/)
]],


    });



  }
  ngOnInit() {
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.userEmail = sessionStorage.getItem('userEmail');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
      if(this.loggedInUserRole === 'Admin'){
        this.adminData = {
          adminId: Number(sessionStorage.getItem('loggedInUserId')) || null,
          adminName: String(this.loggedInUserName) || '',
          adminEMail: String(this.userEmail) || '',
        }
      }
    }
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.getpmsyearlist();
  }
  hasError(controlName: any, errorType: any) {
    const control = this.condidateForm.get(controlName);
    return control?.hasError(errorType) && control.touched;
  }

  cancelbutton() {
    this.dialogRef.close();
  }



  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
  
      this.setSelectedYear(yearValue);
      this.getCompanyDataByCompID();
    // Additional function calls
    
    });
  }
setSelectedYear(yearValue: string): void {
  const selectedYearObj = this.pmsYears.find((ele:any) => ele.year === yearValue);
  if (selectedYearObj) {
    this.selectedYear = selectedYearObj?.year;
    let test = selectedYearObj?.year.split('-');
       
  }
}

  emailOfHrAdmin: any;
  checkHRName: any;
  hrID:any;
  getCompanyDataByCompID() {

    this.httpService.callGetService(this.config.getCompanyDataByCompID + this.loggedInUserCompanyID).subscribe((data: any) => {

      console.log(data?.data);
      this.checkHRName = data?.data.firstnameOfHrAdmin +" " + data?.data.lastnameOfHrAdmin
      this.emailOfHrAdmin = data?.data?.emailOfHrAdmin;
this.hrID=data?.data?.companyHrId;


    })
  }

  addSubmitForm: boolean = false;

  isSubmitting = false; // Prevent multiple submissions

  savecandidatedata() {
  if (this.isSubmitting) return; // Prevent duplicate API calls

  if (this.condidateForm.invalid) {
    this.addSubmitForm = true;
    this.condidateForm.markAllAsTouched();
    return;
  }

  this.isSubmitting = true; // Set flag to prevent multiple calls

  let formData = {
    "companyId": this.loggedInUserCompanyID,
    "salutation": this.condidateForm.value.solutation,
    "firstName": this.condidateForm.value.firstName,
    "lastName": this.condidateForm.value.lastName,
    "candidateEmail": this.condidateForm.value.mail,
    "fiscalYear": this.loggedInCompanyFiscalyear,
    "year": this.selectedYear,
    "hrId": this.adminData.adminId || this.hrID,
    "hrName": this.adminData.adminName || this.checkHRName,
    "hrMail": this.adminData.adminEMail || this.emailOfHrAdmin
  };

  this.httpService.callPostService(`${this.config.candidtaeform}`, formData).subscribe(
    (response: any) => {
      this.showPopup("Added Successfully", 'success', true);
      this.isSubmitting = false; // Reset flag
    },
    (error: any) => {

      this.showPopup(error?.error.message || 'An error occurred.', 'danger', false);
      this.isSubmitting = false; // Reset flag
    }
  );
}

// Reusable popup function
showPopup(message: string, color: string, isSuccess: boolean) {
  const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
    disableClose: true,
    height: '25%',
    width: '30%',
    data: {
      msg: message,
      btn2: 'OK',
      btn2BgColor: color,
      showSuccessIcon: isSuccess,
      showSuccessMessage: false,
      showCloseIcon: !isSuccess
    }
  });

  dialogRef.afterClosed().subscribe(() => {
    if (isSuccess) this.dialogRef.close(); // Close only on success
  });
}

}
